import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  FormFeedback,
  Input,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesOtrosEgresos,
  resourcesOperators,
  resourcesUnits,
} from "../../../helpers/backend_helper";
import { Alert } from "../../../helpers/alerts/alertHelper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as Yup from "yup";
import { useFormik } from "formik";
import NibbleInput from "../../../components/Fields/NibbleInput";

const AddUpdModal = ({
  modal,
  setModal,
  item,
  filtersItems,
  setFiltersItems,
  selects
}) => {
  const [filters, setFilters] = useState({
    route_id: item.route_id,
    select: true,
  });
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const save = async (data) => {
    setLoading(true);
    const response = await resourcesOtrosEgresos(
      modal.update ? "put" : "post",
      data,
      modal.update ? data.id : null
    );
    if (response?.status) {
      setFiltersItems(filtersItems);
      setModal({ ...modal, show: false, update: false });
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: item,
    validationSchema: Yup.object({
      unidad_id: Yup.number().nullable().required("Requerido"),
      operador_id: Yup.number().nullable().required("Requerido"),
      concepto: Yup.string().nullable().required("Requerido"),
      monto: Yup.number().nullable().required("Requerido"),
      fecha: Yup.string().nullable().required("Requerido"),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  useEffect(() => {
    if(validation.values.unit_id) {
      let operator = selects.operators.filter(e=>e.unit_id == validation.values.unit_id)
      operator = operator.length > 0 ? operator[0]:null
      if(operator)
        validation.setFieldValue('operador_id', operator.id)
    }
      
  }, [validation.values.unit_id]);

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar" : "Agregar"} Otros Egresos
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <NibbleInput
                md={6}
                label="Unidad / Camión:"
                fieldName="unidad_id"
                fieldType="select"
                selectItems={selects.units}
                selectOptionLabel={(e) => e.number}
                validation={validation}
              />
			  <NibbleInput
                md={6}
                label="Operador:"
                fieldName="operador_id"
                fieldType="select"
                selectItems={selects.operators}
                selectOptionLabel={(e) => e.full_name}
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Concepto:"
                fieldName="concepto"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Monto:"
                fieldName="monto"
                fieldType="number"
                validation={validation}
              />
			  <NibbleInput
                md={6}
                label="Fecha:"
                fieldName="fecha"
                fieldType="date"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fas fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fas fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
